import React from 'react';
import Select from './Select';

/**
 * Componente MultiSelect personalizado que permite la selección de múltiples opciones.
 * Es una envoltura del componente Select con la propiedad `isMulti` activada por defecto.
 * 
 * @param {Object} props - Propiedades del componente, heredadas de Select.
 * @param {Array} props.options - Opciones del select en formato [{value: '', label: ''}].
 * @param {Array} props.value - Array de objetos de las opciones seleccionadas.
 * @param {Function} props.onChange - Función que se ejecuta cuando cambia el valor. Devuelve un array de las opciones seleccionadas.
 * @param {string} [props.label] - Etiqueta del select.
 * @param {string} [props.placeholder] - Texto de placeholder.
 * @param {string} [props.error] - Mensaje de error a mostrar.
 * @param {boolean} [props.isDisabled] - Si el select está deshabilitado.
 * @returns {JSX.Element}
 */
const MultiSelect = ({
  id,
  name,
  options,
  onChange,
  value,
  label,
  placeholder = 'Seleccionar...',
  error = '',
  isDisabled = false,
  ...rest
}) => {
  return (
    <Select
      id={id}
      name={name}
      options={options}
      onChange={onChange}
      value={value}
      label={label}
      placeholder={placeholder}
      error={error}
      isDisabled={isDisabled}
      isMulti={true} // Siempre será un selector múltiple
      {...rest} // Pasa cualquier otra propiedad al componente Select
    />
  );
};

export default MultiSelect;
